import { ApplicationSettingLink } from '@era/settings-sdk';
import { createActionGroup, props } from '@ngrx/store';
import { CategoryApplicationSetting, CategoryType } from './app-settings.state';
import { ErrorModel } from '@era/app';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const AppSettingsResolverActions = createActionGroup({
  source: 'App Settings Resolver',
  events: {
    'App Settings requested': props<{ bundleIdentifier: string; categoryType: CategoryType; categoryId: string }>(),
  },
});

// ============================================================================
// UI ACTIONS (Group - using createActionGroup)
// ============================================================================

export const AppSettingsModalActions = createActionGroup({
  source: 'App Settings Modal',
  events: {
    'App settings updated': props<{
      categoryId: string;
      categoryType: CategoryType;
      bundleIdentifier: string;
      oldSettings: CategoryApplicationSetting[];
      newSettings: CategoryApplicationSetting[];
    }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const AppSettingsApiActions = createActionGroup({
  source: 'App Settings API',
  events: {
    'App Settings loaded': props<{ settings: CategoryApplicationSetting[] }>(),
    'App Settings updated': props<{
      categoryType: CategoryType;
      categoryId: string;
      bundleIdentifier: string;
      settings: CategoryApplicationSetting[];
    }>(),
    'App Settings updated error': props<{ error: ErrorModel }>(),
    'App Settings loaded error': props<{ error: ErrorModel }>(),
    'App Settings linked to category': props<{ applicationSettingLink: ApplicationSettingLink }>(),
    'App Settings unlinked from category': props<{ settingId: string }>(),
    'App Settings linked error': props<{ error: ErrorModel }>(),
    'App Settings unlinked error': props<{ error: ErrorModel }>(),
  },
});
